
export const MAX_MONTHS = 1200;


export const DEFAULT_TARGETS = {
  EMERGENCY_FUND: 50000,      
  FIRST_100K: 100000,         
  HOUSE_DOWN_PAYMENT: 200000,
  RETIREMENT_FUND: 500000,
  FINANCIAL_FREEDOM: 1000000 
};


export const DEFAULT_VALUES = {
  TARGET_AMOUNT: "100000", 
  INITIAL_VALUE: "",
  MONTHLY_VALUE: "", 
  INTEREST_RATE: "10",
  TARGET_PERIOD: "5",
  PERIOD_TYPE: "ano(s)", 
  INTEREST_TYPE: "anual"
};


export const INVESTMENT_PROFILES = {
  CONSERVATIVE: {
    name: "Conservador",
    annualRate: 6,
    description: "Poupança, CDB, Tesouro Selic",
    color: "gray"
  },
  MODERATE: {
    name: "Moderado", 
    annualRate: 10,
    description: "Tesouro IPCA+, Fundos DI",
    color: "blue"
  },
  AGGRESSIVE: {
    name: "Arrojado",
    annualRate: 15,
    description: "Ações, Fundos Imobiliários, Renda Variável",
    color: "orange"
  }
};


export const UI_CONFIG = {
  QUICK_TARGET_BUTTONS: [
    { value: DEFAULT_TARGETS.EMERGENCY_FUND, label: "R$ 50k", description: "Emergência", color: "blue" },
    { value: DEFAULT_TARGETS.FIRST_100K, label: "R$ 100k", description: "Primeira Centena", color: "green" },
    { value: DEFAULT_TARGETS.HOUSE_DOWN_PAYMENT, label: "R$ 200k", description: "Casa", color: "purple" },
    { value: DEFAULT_TARGETS.FINANCIAL_FREEDOM, label: "R$ 1M", description: "Liberdade", color: "yellow" }
  ],
  
  QUICK_RATE_BUTTONS: [
    { value: "6", label: "6%", description: "Conservador", color: "gray" },
    { value: "10", label: "10%", description: "Moderado", color: "blue" },
    { value: "15", label: "15%", description: "Arrojado", color: "orange" }
  ]
};